import React, { Component } from "react";
import "./DealerLocation.scss";
import DealerLocationCard from "components/DealerLocationCard/DealerLocationCard";
import Select from "react-select";
import { uepClient } from "uepClient";
import Scrollbars from "components/Scrollbars/Scrollbars";
import { BsSearch } from "react-icons/bs";
import axios from "axios";
import DealerLocationTabService from "services/DealerLocationTabService";
import { BiErrorCircle } from "react-icons/bi";
import _colors from "styles/colors.module.scss";
import { Spinner } from "react-bootstrap";
const { orange } = _colors;

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: 40,
    minHeight: 40,
    fontSize: "1em",
    background: "white",
    boxShadow: "0px 3px 6px #00000012",
    border: "none",
    color: "#838EAB",
  }),
  option: (provided, { isSelected, isFocused }) => ({
    ...provided,
    height: 34,
    minHeight: 34,
    letterSpacing: "0px",
    color: "#838EAB",
    fontWeight: isFocused ? "bold" : "normal",
    fontSize: "1em",
    backgroundColor: isSelected || isFocused ? "#E6EBF1" : "white",
    border: "none",
  }),
  placeholder: (base) => ({
    ...base,
    text: "Select Category",
    color: "#838EAB",
    fontSize: "1.2em",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    width: 28,
    paddingTop: 0,
    paddingBottom: 0,
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#838EAB",
    fontSize: "1.2em",
  }),
};

export default class DealerLocation extends Component {
  constructor() {
    super();
    this.state = {
      radius: null,
      latitude: null,
      longitude: null,
      searchKeyword: "",
      dealerLocations: [],
      radiusOptions: [25, 50, 100, 150],
      showError: false,
      errorMessage: "",
      isLoading: false,
    };
  }

  componentDidMount() {
    this.dealerTabServiceSubscription = DealerLocationTabService.listen().subscribe(
      this.onActiveLocationMessageSet
    );
  }

  onActiveLocationMessageSet = (message) => {
    if (message && message.latitude && message.longitude) {
      this.setState(
        {
          latitude: message.latitude,
          longitude: message.longitude,
          searchKeyword: "",
          showError: false,
          errorMessage: "",
        },
        this.fetchNearestDealerLocations
      );
    }
  };

  fetchLatitudeLongitudeForLocationKeyword() {
    const encryptedGoogleAPIKey = window.apiKeys.googleAPIKey;
    const decryptedGoogleAPIKey = atob(encryptedGoogleAPIKey);

    const { searchKeyword } = this.state;
    const transformedSearchKeyword = searchKeyword.replace(" ", "+");
    this.setState({ isLoading: true });
    axios
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${transformedSearchKeyword}&key=${decryptedGoogleAPIKey}`
      )
      .then((response) => {
        this.setState(
          {
            isLoading: false,
            latitude: response.data.results[0].geometry.location.lat,
            longitude: response.data.results[0].geometry.location.lng,
            showError: false,
            errorMessage: "",
          },
          this.fetchNearestDealerLocations
        );
      })
      .catch((error) => {
        console.error(
          `An error occured while trying to fetch latitude & longitude for the given location : ${error.message}`
        );
        this.setState({
          isLoading: false,
          latitude: null,
          longitude: null,
          searchKeyword: "",
          dealerLocations: [],
          showError: true,
          errorMessage:
            "The location could not be found. Please enter a different location",
        });
      });
  }

  fetchNearestDealerLocations() {
    const { radius, latitude, longitude } = this.state;

    if (radius && latitude && longitude) {
      const payload = {
        userLatitude: latitude,
        userLongitude: longitude,
        radius: radius,
      };
      this.setState({ isLoading: true });
      uepClient()
        .post(`/dealer-location`, payload)
        .then((response) => {
          if (response.data.length > 0) {
            const dealers = response.data.map((dealerLocation) => ({
              address: dealerLocation.address,
              dealerName: dealerLocation.dealerName,
              distanceInMeters: dealerLocation.distanceInMeters,
              latitude: dealerLocation.latitude,
              longitude: dealerLocation.longitude,
              state: dealerLocation.state,
            }));
            this.setState({
              isLoading: false,
              dealerLocations: dealers,
              showError: false,
              errorMessage: "",
            });
          } else {
            this.setState({
              isLoading: false,
              dealerLocations: [],
              showError: true,
              errorMessage: "No workshop was found in the given radius.",
            });
          }
        })
        .catch((error) => {
          console.error(
            `An Error occured while fetching dealer locations : ${error.message}`
          );
          this.setState({
            isLoading: false,
            dealerLocations: [],
            showError: true,
            errorMessage: "Looks like something went wrong. Please try again",
          });
        });
    } else {
      this.setState({ dealerLocations: [] });
    }
  }

  renderDealerLocations() {
    return (
      <div className="dealer-locations-section">
        {this.renderDealerLocationCards()}
      </div>
    );
  }

  renderDealerLocationCards() {
    const { dealerLocations } = this.state;

    if (dealerLocations.length > 0) {
      return dealerLocations.map((dealerLocation, index) => (
        <DealerLocationCard key={index} dealerLocation={dealerLocation} />
      ));
    } else return "";
  }

  onSearchKeywordEnter = (e) => {
    if (e.which === 13) {
      this.fetchLatitudeLongitudeForLocationKeyword();
    }
  };

  onSearchKeywordChange = (e) => {
    const newSearchText = e.target.value;
    this.setState({
      searchKeyword: newSearchText,
    });
    if (newSearchText.trim().length === 0) {
      this.setState({
        latitue: null,
        longitude: null,
      });
    }
  };

  onRadiusOptionChange = (selectedOption, triggeredAction) => {
    if (triggeredAction.action === "clear") {
      this.setState({
        radius: null,
        dealerLocations: [],
        showError: false,
        errorMessage: "",
      });
    } else {
      this.setState(
        {
          radius: selectedOption.value,
        },
        this.fetchNearestDealerLocations
      );
    }
  };

  render() {
    let options = this.state.radiusOptions.map(function (radius) {
      return { value: radius, label: radius };
    });

    const { searchKeyword, showError, errorMessage, isLoading } = this.state;

    return (
      <div className="dealer-location-container">
        <div className="dealer-location-listing">
          <div className="search-input-with-icon">
            <BsSearch className="search-icon" size="1em" />
            <input
              className="search-input"
              type="text"
              value={searchKeyword}
              onKeyPress={this.onSearchKeywordEnter}
              placeholder="Search Location"
              onChange={this.onSearchKeywordChange}
            />
          </div>
          <div className="location-radius">
            <Select
              isClearable
              options={options}
              styles={customStyles}
              placeholder="Select Radius"
              onChange={this.onRadiusOptionChange}
            />
          </div>
          <hr></hr>
          {showError && !isLoading && (
            <div className="error-message">
              <BiErrorCircle
                size="1.5em"
                color={orange}
                className="error-icon"
              />
              <div className="error-text">{errorMessage}</div>
            </div>
          )}
          {isLoading ? (
            <Spinner
              animation="border"
              size="1em"
              variant="primary"
              className="dealer-location-spinner"
            />
          ) : (
            <Scrollbars className="scrollable-dealer-listing">
              {this.renderDealerLocations()}
            </Scrollbars>
          )}
        </div>
      </div>
    );
  }
}
